import { useEffect, useState } from 'react';
import PostingsApi from '../../../../../API/shipment/postings-api';
import ShipmentsApi from '../../../../../API/shipment/shipments-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Select } from '../../../../../components/Basic/Inputs';
import { H2, Text } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import { getDate } from '../../../../../utils';
import styles from './styles.module.scss';

const MovePostingsToShipmentPopUp = ({
  close = () => {},
  market = '',
  shop = '',
  date = '',
  postings = [],
  num = '',
}) => {
  const [shipments, setShipments] = useState([]);
  const [selectShipment, setSelectShipment] = useState(null);

  const clickChangeShipment = async () => {
    await PostingsApi.changePostings({
      data: { postingNumbers: postings, field: 'shipment_id', value: selectShipment.id },
    });
    close();
  };

  let loadShipments = async () => {
    let r_started = await ShipmentsApi.getShipments({ data: { status: 'new', market, limit: 10 } }).then(
      (r) => r.shipments,
    );
    let r_new = await ShipmentsApi.getShipments({ data: { status: 'started', market, limit: 10 } }).then(
      (r) => r.shipments,
    );

    console.log(r_new, r_started);
    setShipments([...r_new, ...r_started]);
  };

  useEffect(() => {
    loadShipments();
  }, []);

  console.log(shipments);
  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить в отгрузку</H2>

      <Select
        list={shipments}
        select={selectShipment}
        label={'Отгрузка'}
        valueFn={(item) =>
          item
            ? `${item.market} ${getDate(item.time_scheduled)} ${item.sklad} ${item.is_express ? 'express' : ''}`
            : null
        }
        onSelect={(v) => setSelectShipment(v)}
      />

      <Text fontSize={15} style={{ marginTop: '10px' }}>{`Количество заказов ${num}`}</Text>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          onClick={clickChangeShipment}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default MovePostingsToShipmentPopUp;
